import {
  InMemoryHeader,
  InMemoryString,
  InMemoryBoolean,
  InMemoryDate
} from "pbas-vue-components";
import {
  translate
} from '../trans'
import store from '@/store'

function getMemberDependantsHeaders(planType) {
  if (planType==="Pension") {
    return [
      new InMemoryHeader({
        title: "headers.memberdependants.id",
        type: new InMemoryString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1,
      }),
      new InMemoryHeader({
        title: "headers.in_memory_dependants.pension_spouse_id",
        type: new InMemoryString("Identity/PensionSpouseId"),
        sortable: true,
        visible: true,
        searchable: true
      }),
      new InMemoryHeader({
        title: "headers.members_management.SIN",
        type: new InMemoryString("SIN"),
        sortable: true,
      }),
      new InMemoryHeader({
        title: "headers.members_management.Title",
        type: new InMemoryString("Title", {
          getString: item => {
            if (!item) return "";
            const lang = store.getters['common/language']
            return translate(item.Title, lang.language);
          }
        }),
        sortable: true,
      }),
      new InMemoryHeader({
        title: "globals.firstname",
        type: new InMemoryString("FirstName"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "globals.middlename",
        type: new InMemoryString("MiddleName"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "globals.lastname",
        type: new InMemoryString("LastName"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "headers.members_management.Suffix",
        type: new InMemoryString("Suffix", {
          getString: item => {
            if (!item) return "";
            const lang = store.getters['common/language']
            return translate(item.Suffix, lang.language);
          }
        }),
        sortable: true,
      }),
      new InMemoryHeader({
        title: "globals.dob",
        type: new InMemoryDate("DateOfBirth"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "components.inmemorydependants.dod",
        type: new InMemoryDate("DateOfDeath"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "globals.gender",
        type: new InMemoryString("Gender", {
          getString: item => {
            if (!item) return "";
            const lang = store.getters['common/language']
            return translate(item.Gender, lang.language);
          }
        }),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "components.inmemorydependants.relationship",
        type: new InMemoryString("Relationship", {
          getString: item => {
            if (!item) return "";
            const lang = store.getters['common/language']
            return translate(item.Relationship, lang.language);
          }
        }),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "globals.plan_entry_date",
        type: new InMemoryDate("Identity/CoverageEffectiveDate"),
        sortable: true,
        version: 1,
      }),
      new InMemoryHeader({
        title: "components.inmemorydependants.spousal_waiver",
        type: new InMemoryBoolean("Identity/Qualification/SpousalWaiverDate", {
          getValue: (item) => {
            return item.Identity.Qualification.SpousalWaiverDate !== null && item.Identity.Qualification.SpousalWaiverDate !== undefined
          }
        }),
        sortable: true,
        visible: true,
        searchable: true,
        version: 1
      }),
    ];
  }
  return [
    new InMemoryHeader({
      title: "headers.memberdependants.id",
      type: new InMemoryString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.memberview.eligible",
      type: new InMemoryBoolean("Identity/IsEligible"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true
    }),
    new InMemoryHeader({
      title: "headers.members_management.Title",
      type: new InMemoryString("Title", {
        getString: item => {
          if (!item) return "";
          const lang = store.getters['common/language']
          return translate(item.Title, lang.language);
        }
      }),
      sortable: true,
    }),
    new InMemoryHeader({
      title: "globals.firstname",
      type: new InMemoryString("FirstName"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "globals.middlename",
      type: new InMemoryString("MiddleName"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "globals.lastname",
      type: new InMemoryString("LastName"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "headers.members_management.Suffix",
      type: new InMemoryString("Suffix", {
        getString: item => {
          if (!item) return "";
          const lang = store.getters['common/language']
          return translate(item.Suffix, lang.language);
        }
      }),
      sortable: true,
    }),
    new InMemoryHeader({
      title: "globals.dob",
      type: new InMemoryDate("DateOfBirth"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.dod",
      type: new InMemoryDate("DateOfDeath"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "globals.gender",
      type: new InMemoryString("Gender", {
        getString: item => {
          if (!item) return "";
          const lang = store.getters['common/language']
          return translate(item.Gender, lang.language);
        }
      }),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.relationship",
      type: new InMemoryString("Relationship", {
        getString: item => {
          if (!item) return "";
          const lang = store.getters['common/language']
          return translate(item.Relationship, lang.language);
        }
      }),
      sortable: true,
      version: 1,
    }),
    // new InMemoryHeader({
    //   title: "Eligibility",
    //   type: new InMemoryBoolean("Eligibility"),
    //   sortable: true,
    //   version: 1,
    // }),
    // new InMemoryHeader({
    //   title: "Current Coverage",
    //   type: new InMemoryString("CurrentCoverage"),
    //   sortable: true,
    //   version: 1,
    // }),
    new InMemoryHeader({
      title: "globals.plan_entry_date",
      type: new InMemoryDate("Identity/CoverageEffectiveDate"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.school_completion_date",
      type: new InMemoryDate("Identity/Qualification/SchoolCompletionDate"),
      sortable: true,
      version: 1,
    }),
    // new InMemoryHeader({
    //   title: "COB",
    //   type: new InMemoryBoolean("COB"),
    //   sortable: true,
    //   version: 1,
    // }),
    new InMemoryHeader({
      title: "globals.inactive",
      type: new InMemoryBoolean("IsRemoved"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.student",
      type: new InMemoryBoolean("Student"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.disabled",
      type: new InMemoryBoolean("Disabled"),
      sortable: true,
      version: 1,
    }),
    new InMemoryHeader({
      title: "components.inmemorydependants.overage",
      type: new InMemoryBoolean("Overage"),
      sortable: true,
      version: 1,
    }),
  ]
}
export default getMemberDependantsHeaders;